/**
 * Generates a compare page URL based on the page alias and selected vehicles.
 * @param {string[]} compareVehicles - Array of vehicle UUIDs
 * @param {Object} sitemap - Sitemap object with get() method from useSitemap hook
 * @param {string} pageAlias - Current page alias identifier
 * @returns {string} Complete compare page URL with query parameters, or empty string if no sitemap URL found
 */
export const getCompareLink = ({ compareVehicles, sitemap, pageAlias }) => {
	if (!sitemap) return '';

	// Determine the correct compare vehicles page URL based on the page alias
	const compareVehiclesPageUrl =
		pageAlias === 'DEAL_CENTRAL_INVENTORY_LISTING'
			? sitemap.get('DEAL_CENTRAL_INVENTORY_VEHICLE_COMPARE')
			: sitemap.get('INVENTORY_VEHICLE_COMPARE_DEFAULT');

	return compareVehiclesPageUrl
		? compareVehiclesPageUrl
				.concat(
					`?itemIds=${encodeURIComponent(compareVehicles.join())}`
				)
				.concat(`&searchResultsPage=${encodeURIComponent(pageAlias)}`)
		: '';
};
